// extracted by mini-css-extract-plugin
module.exports = {"item":"moreRecipientsChip_item__fvVeK commonStyles_typography__2kf2S","button":"moreRecipientsChip_button__dh751"};